<template>
    <span v-html="order.productionStatusLabel" :class="orderProductionStatusClasses"/>
</template>

<script>
export default {
    name: "DistributionOrderProductionStatus",
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        orderProductionStatusClasses() {
            const statusColors = {
                pending: "warning",
                preparing: "info",
                shipping: "info",
                shipped: "success",
                delivered: "success",
                canceled: "danger",
            };
            return `badge badge-${statusColors[this.order.status.production]}`;
        },
    },
};
</script>

<style scoped>

</style>